const en = {
  HEADER_TITLE: "Q3 2020",
  PREVIOUS_ISSUES: "Previous Issues",
  LINK_REIT: "Link REIT",
  CHANNEL_823: "Channel 823",
  HOME: "Home",
  CEOS_VIEWS: "CEO's Views",
  CORPORATE_NEWS: "Corporate News",
  FEATURE_STORIES: "Feature Stories",
  LINK_TOGETHER_INITIATIVES: "Link Together Initiatives",
  THE_LINK_MOMENTS: "The Link Moments",
  CLOSE: "Close",
  MENU: "Menu",
  COPYRIGHT_DISCLAIMER: "Copyright & Disclaimer",
  ALL_RIGHT_RESERVED:
    "© Copyright Link Asset Management Limited. All rights reserved.",
  LINKEDIN: "Link REIT LinkedIn",
  TWITTER: "Link REIT Twitter",
  FACEBOOK: "Link Together Initiatives Facebook",
  INSTAGRAM: "Link REIT Instagram",
  YOUTUBE: "Link REIT YouTube",
  WEIBO: "Link REIT Weibo",
  WECHAT: "Link REIT WeChat",
  SCAN_IN_WECHAT: "Scan in WeChat",
  LINKS_WECHAT_PAGE: "Link’s WeChat page",
  LINKS_WEIBO_PAGE: "Link’s Weibo page",
  COVER: "Cover",
  BACK_TO_TOP: "Back to Top",
  TOP: "Top",
  LINK_REIT_WECHAT_QR_CODE: "Link REIT WeChat QR code",
  STORY1: "Bespoke <br/>Internship",
  STORY2: "Entrepreneurship <br/>101",
  STORY3: "Extraordinary <br/>Summer",
  COVER_IMG_TITLE: "Rising Stars at Link",
  READ_MORE: "More",
}
export default en
